import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-white pt-20 pb-10" data-id="element-92">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12" data-id="element-93">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-94">
          {/* Brand & Intro */}
          <div className="lg:col-span-1" data-id="element-95">
            <Link to="/" className="mb-6 block" data-id="element-96">
              <img src="https://cdn.magicpatterns.com/uploads/7P7Rjqo6jkpinM1q8K3tpA/Logo_zonder_tekst.png" alt="Mijn bedrijfswaarderingen" className="h-16 w-auto" data-id="element-97" />
            </Link>
            <p className="text-warmgray/70 text-sm leading-relaxed mb-6" data-id="element-98">
              Onafhankelijke, professionele bedrijfswaarderingen voor
              MKB-ondernemers. Strategisch inzicht voor verkoop, overname en
              geschillen.
            </p>
            <Link to="/bedrijfswaardering" className="inline-flex items-center text-accent hover:text-white transition-colors text-sm font-medium group" data-id="element-99">
              Start waardebepaling
              <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-100" />
            </Link>
          </div>

          {/* Diensten */}
          <div data-id="element-101">
            <h4 className="text-lg font-medium mb-6" data-id="element-102">Diensten</h4>
            <ul className="space-y-4" data-id="element-103">
              <li data-id="element-104">
                <Link to="/bedrijfswaardering" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-105">
                  Bedrijfswaardering
                </Link>
              </li>
              <li data-id="element-106">
                <Link to="/bedrijfswaardering-verkoop" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-107">
                  Waardering bij Verkoop
                </Link>
              </li>
              <li data-id="element-108">
                <Link to="/bedrijfswaardering-overname" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-109">
                  Waardering bij Overname
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/bedrijfswaardering-scheiding" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-111">
                  Waardering bij Scheiding
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/bedrijfswaardering-interne-overdracht" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-113">
                  Interne Overdracht
                </Link>
              </li>
            </ul>
          </div>

          {/* Navigatie */}
          <div data-id="element-114">
            <h4 className="text-lg font-medium mb-6" data-id="element-115">Navigatie</h4>
            <ul className="space-y-4" data-id="element-116">
              <li data-id="element-117">
                <Link to="/werkwijze" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-118">
                  Werkwijze
                </Link>
              </li>
              <li data-id="element-119">
                <Link to="/kennisbank" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-120">
                  Kennisbank
                </Link>
              </li>
              <li data-id="element-121">
                <Link to="/adviseurs" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-122">
                  Onze Adviseurs
                </Link>
              </li>
              <li data-id="element-123">
                <Link to="/over-ons" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-124">
                  Over Ons
                </Link>
              </li>
              <li data-id="element-125">
                <Link to="/contact" className="text-warmgray/70 hover:text-accent transition-colors text-sm" data-id="element-126">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-127">
            <h4 className="text-lg font-medium mb-6" data-id="element-128">Contact</h4>
            <ul className="space-y-4" data-id="element-129">
              <li className="flex items-start gap-3 text-warmgray/70 text-sm" data-id="element-130">
                <MapPin size={18} className="text-accent shrink-0 mt-0.5" data-id="element-131" />
                <span data-id="element-132">
                  Zuidas 123
                  <br data-id="element-133" />
                  1082 MM Amsterdam
                </span>
              </li>
              <li className="flex items-center gap-3 text-warmgray/70 text-sm" data-id="element-134">
                <Phone size={18} className="text-accent shrink-0" data-id="element-135" />
                <span data-id="element-136">020 - 123 45 67</span>
              </li>
              <li className="flex items-center gap-3 text-warmgray/70 text-sm" data-id="element-137">
                <Mail size={18} className="text-accent shrink-0" data-id="element-138" />
                <span data-id="element-139">info@waardebepaling.nl</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-140">
          <p className="text-warmgray/50 text-xs" data-id="element-141">
            &copy; {new Date().getFullYear()} Waardebepaling.nl. Alle rechten
            voorbehouden.
          </p>
          <div className="flex gap-6" data-id="element-142">
            <Link to="#" className="text-warmgray/50 hover:text-white text-xs transition-colors" data-id="element-143">
              Privacybeleid
            </Link>
            <Link to="#" className="text-warmgray/50 hover:text-white text-xs transition-colors" data-id="element-144">
              Cookiebeleid
            </Link>
            <Link to="#" className="text-warmgray/50 hover:text-white text-xs transition-colors" data-id="element-145">
              Algemene Voorwaarden
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}